/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import { API_HOST, API_PATH } from "../../../config/_entrypoint";
import Grid from "@mui/material/Grid";
import DownloadIcon from "@mui/icons-material/CloudDownload";
import downloadTileStyle from "./downloadTileStyle";
import { Box, Button, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import { MediaObject } from "../../../types/Entities/MediaObject/MediaObject";

type DownloadTileProps = {
  mediaObject: MediaObject;
  size?: "large" | "small" | "minimal";
};

const DownloadTile = ({ mediaObject, size = "large" }: DownloadTileProps) => {
  const downloadLink = API_HOST + API_PATH + "/download/" + mediaObject.id + "?token=" + localStorage.getItem("token");
  const bgImage = "url(" + downloadLink + "&thumbNail=1)";
  const descriptionStyle = size !== "large" ? (size === "small" ? downloadTileStyle.narrowText : downloadTileStyle.minimalText) : {};
  const containerStyle =
    size === "large" ? downloadTileStyle.largeContainer : size === "small" ? downloadTileStyle.smallContainer : downloadTileStyle.minimalContainer;

  return (
    <>
      <Grid
        container
        component={"a"}
        download
        href={downloadLink}
        sx={{
          alignItems: "center",
          backgroundImage: bgImage,
          ...downloadTileStyle.container,
          ...containerStyle,
        }}
      >
        <Grid sx={downloadTileStyle.cta}>
          <Stack direction={"column"} sx={{
            alignItems: "center",
            textAlign: "center"
          }}>
            <DownloadIcon sx={downloadTileStyle.icon} />
            <Typography variant={size === "minimal" ? "body2" : "inherit"} color={"primary"}>HERUNTERLADEN</Typography>
          </Stack>
        </Grid>
      </Grid>
      <Box sx={downloadTileStyle.title}>
        <Typography align={"center"} sx={descriptionStyle} variant={size === "minimal" ? "body2" : "inherit"}>
          {mediaObject.description}
        </Typography>
      </Box>
    </>
  );
};

export default DownloadTile;
